// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"86c8bb4b","410":"90ac7c68","510":"24c7e653","936":"c06e6985","947":"2387893f"}[chunkId] + ".chunk.js";
};